import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/saga-blue/theme.css'; 
import 'primereact/resources/primereact.min.css'; 
import LeadsAssignedService from '../../services/LeadsAssignedService';
import AuthService from '../../services/AuthService';
import LeadService from '../../services/LeadService';
import ToastService from '../../services/ToastService';
import { LEAD_STATUSES, PROPERTY_TYPES, STATUS_COLORS } from '../../constants/leadConstants';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}
 
function AddLeadsAssigned() {
    const queryParam = useQuery();
    const navigate = useNavigate();
    const toast = useRef(null);
    const toastService = new ToastService(toast); 
    const [leadsAssigned, setLeadsAssigned] = useState([]);
    const [leadsAssignedId] = useState([]);
    const [leads, setLeads] = useState([]);
    const [selectedLeadId, setSelectedLeadId] = useState(queryParam.get('leadId'));
    const [UserId] = useState(() => AuthService.resolveScopedUserId(queryParam.get("id")));
  
    const [form, setForm] = useState({
      leadId: selectedLeadId,
      leadStatusId: "",
      propertyTypeId: "",
      userId: UserId, 
      conversationcomment:"",
      leadassigneddate:"",
      followupdate:"",
      nextupdate:"",
    });
  
    const [formError, setFormError] = useState({}); 
  
    const LeadStatus = LEAD_STATUSES;
    const PropertyType = PROPERTY_TYPES;
    
  
    const changeHandler = (e) => {
      const { name, value } = e.target;
      setForm({ ...form, [name]: value });
      setFormError((prevErrors) => ({ ...prevErrors, [name]: '' })); 
    };
    
  
    async function getAll() {
      try {
        const leadsAssignedData = await LeadsAssignedService.getAllLeadsAssigned();
        setLeadsAssigned(leadsAssignedData);
      } catch (error) {
        console.log('Error fetching leads: ', error);
      }
    }
  
    useEffect(() => {
      getAll();
  }, [leadsAssignedId]);

  useEffect(() => {
    async function fetchLeads() {
      try {
        const leads = await LeadService.getLeadsByUserId(AuthService.getLoggedInUserId());
        setLeads(leads);
      } catch (error) {
        console.error('Error fetching leads:', error);
      }
    }
   
    fetchLeads(); 
  }, []);

  function onLeadAssignedSubmit() {
    const errors = {
      conversationcomment: form.conversationcomment.trim().length === 0,
      leadassigneddate: form.leadassigneddate.trim().length === 0,
      followupdate: form.followupdate.trim().length === 0,
      nextupdate: form.nextupdate.trim().length === 0,
    };

    const error = Object.keys(errors).reduce((acc, key) => {
      if (errors[key]) {
        return {
          ...acc, 
          [key]: `Please enter ${key}!!!`,
        };
      }
      return acc;
    }, {}); 

    setFormError(error);
    if (Object.keys(error).length === 0) {
       saveLeadAssigned()
    }
  }

  async function saveLeadAssigned() {

    if (!selectedLeadId) {
        toastService.showError("Error", "Please select a lead");
        return;
      }

      const requestData = {
        leadId: selectedLeadId,
        leadassigneddate: form.leadassigneddate,
        conversationcomment: form.conversationcomment,
        followupdate: form.followupdate,
        nextupdate: form.nextupdate,
        leadStatusId: form.leadStatusId,
        propertyTypeId:form.propertyTypeId,
        UserId: UserId,
      };
      
      try {
        await LeadsAssignedService.createLeadAssigned(requestData);
        toastService.showSuccess("Success", "Lead assigned successfully!");
        resetForm();
        navigate("/leadassigned");
      } catch (error) {
        if (error.response && error.response.status === 400) {
          toastService.showError("Validation Error", "Please check all required fields");
        } else {
          toastService.showError("Error", "An error occurred while saving the assignment.");
        }
      }
  }

  function resetForm() {
    setForm({
        leadId: "",
        leadStatusId: "",
        propertyTypeId: "",
        userId: "", 
        conversationcomment:"",
        leadassigneddate:"",
    });
    setFormError({
        leadId: "",
        leadStatusId: "",
        propertyTypeId: "",
        userId: "", 
        conversationcomment:"",
        leadassigneddate:"",
    });
  }

  const labelStyle = {
    display: 'block',
    fontSize: '12px',
    fontWeight: '600',
    color: '#8392ab',
    marginBottom: '6px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  };
  const inputStyle = (hasError) => ({
    width: '100%',
    padding: '10px 14px',
    border: `1.5px solid ${hasError ? '#f5365c' : '#e9ecef'}`,
    borderRadius: '10px',
    fontSize: '14px',
    color: '#344767',
    background: '#fff',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s',
  });
  const errorStyle = {
    fontSize: '11px',
    color: '#f5365c',
    marginTop: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  };

  const statusColors = STATUS_COLORS;

  return (
    <div style={{ padding: '24px', minHeight: '100vh', background: '#f4f6fb' }}>
      <Toast ref={toast} />
      <style>{`
        .ala-input:focus { border-color: #344767 !important; box-shadow: 0 0 0 3px rgba(52,71,103,0.1) !important; }
        .ala-select:focus { border-color: #344767 !important; box-shadow: 0 0 0 3px rgba(52,71,103,0.1) !important; outline: none; }
        .ala-submit-btn:hover { opacity: 0.88; transform: translateY(-1px); }
        .ala-cancel-btn:hover { background: #f0f2f5 !important; }
      `}</style>

      {/* Page Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '28px' }}>
        <div style={{
          width: '48px', height: '48px', borderRadius: '12px',
          background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#fff', fontSize: '20px', boxShadow: '0 4px 12px rgba(52,71,103,0.3)',
        }}>
          <i className="fas fa-tasks" />
        </div>
        <div>
          <p style={{ fontSize: '22px', fontWeight: '700', color: '#344767', margin: 0, lineHeight: 1.2 }}>
            Assign New Lead
          </p>
          <p style={{ fontSize: '13px', color: '#8392ab', margin: 0, marginTop: '2px' }}>
            Record lead assignment details, follow-up schedule, and conversation notes
          </p>
        </div>
      </div>

      <div style={{
        background: '#fff', borderRadius: '20px',
        boxShadow: '0 4px 24px rgba(52,71,103,0.08)',
        overflow: 'hidden',
      }}>
        {/* Header strip */}
        <div style={{
          background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
          padding: '20px 28px',
          display: 'flex', alignItems: 'center', gap: '10px',
        }}>
          <i className="fas fa-clipboard-list" style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px' }} />
          <span style={{ color: '#fff', fontWeight: '600', fontSize: '15px' }}>Lead Assignment Form</span>
        </div>

        <div style={{ padding: '32px 28px' }}>

          {/* Row 1: Lead, Assigned Date, Follow Up */}
          <div style={{ marginBottom: '18px', paddingBottom: '10px', borderBottom: '1.5px solid #f0f2f5', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: '30px', height: '30px', borderRadius: '8px', background: '#5e72e418', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#5e72e4', fontSize: '13px' }}>
              <i className="fas fa-calendar-check" />
            </div>
            <p style={{ fontSize: '13px', fontWeight: '700', color: '#344767', textTransform: 'uppercase', letterSpacing: '0.06em', margin: 0 }}>
              Assignment Details
            </p>
          </div>
          <div className="row g-3" style={{ marginBottom: '28px' }}>
            <div className="col-md-4">
              <label style={labelStyle} htmlFor="userId">Select Lead</label>
              <select
                name="userId"
                id="userId"
                className="ala-select"
                style={{ ...inputStyle(!!formError.leadId), appearance: 'none', cursor: 'pointer' }}
                value={selectedLeadId}
                onChange={(e) => setSelectedLeadId(e.target.value)}
              >
                <option value="">— Select a Lead —</option>
                {leads.map((lead) => (
                  <option key={lead.id} value={lead.id}>{lead.firstName}</option>
                ))}
              </select>
              {formError.leadId && <p style={errorStyle}><i className="fas fa-exclamation-circle" />{formError.leadId}</p>}
            </div>
            <div className="col-md-4">
              <label style={labelStyle} htmlFor="leadassigneddate">Lead Assigned Date</label>
              <input
                type="datetime-local"
                id="leadassigneddate"
                name="leadassigneddate"
                className="ala-input"
                style={inputStyle(!!formError.leadassigneddate)}
                onChange={changeHandler}
                value={form.leadassigneddate}
              />
              {formError.leadassigneddate && <p style={errorStyle}><i className="fas fa-exclamation-circle" />{formError.leadassigneddate}</p>}
            </div>
            <div className="col-md-4">
              <label style={labelStyle} htmlFor="followupdate">Follow Up Date</label>
              <input
                type="datetime-local"
                id="followupdate"
                name="followupdate"
                className="ala-input"
                style={inputStyle(!!formError.followupdate)}
                onChange={changeHandler}
                value={form.followupdate}
              />
              {formError.followupdate && <p style={errorStyle}><i className="fas fa-exclamation-circle" />{formError.followupdate}</p>}
            </div>
          </div>

          {/* Row 2: Next Follow Up, Lead Status, Property Type */}
          <div style={{ paddingBottom: '10px', borderBottom: '1.5px solid #f0f2f5', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px' }}>
            <div style={{ width: '30px', height: '30px', borderRadius: '8px', background: '#2dce8918', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#2dce89', fontSize: '13px' }}>
              <i className="fas fa-tag" />
            </div>
            <p style={{ fontSize: '13px', fontWeight: '700', color: '#344767', textTransform: 'uppercase', letterSpacing: '0.06em', margin: 0 }}>
              Status & Classification
            </p>
          </div>
          <div className="row g-3" style={{ marginBottom: '28px' }}>
            <div className="col-md-4">
              <label style={labelStyle} htmlFor="nextupdate">Next Follow Up Date</label>
              <input
                type="datetime-local"
                id="nextupdate"
                name="nextupdate"
                className="ala-input"
                style={inputStyle(!!formError.nextupdate)}
                onChange={changeHandler}
                value={form.nextupdate}
              />
              {formError.nextupdate && <p style={errorStyle}><i className="fas fa-exclamation-circle" />{formError.nextupdate}</p>}
            </div>
            <div className="col-md-4">
              <label style={labelStyle} htmlFor="leadStatusId">Lead Status</label>
              <select
                name="leadStatusId"
                id="leadStatusId"
                className="ala-select"
                style={{ ...inputStyle(!!formError.leadStatusId), appearance: 'none', cursor: 'pointer' }}
                value={form.leadStatusId}
                onChange={changeHandler}
              >
                <option value="">— Select Status —</option>
                {LeadStatus.map(({ id, name }) => (
                  <option key={id} value={id}>{name}</option>
                ))}
              </select>
              {formError.leadStatusId && <p style={errorStyle}><i className="fas fa-exclamation-circle" />{formError.leadStatusId}</p>}
            </div>
            <div className="col-md-4">
              <label style={labelStyle} htmlFor="propertyTypeId">Property Type</label>
              <select
                name="propertyTypeId"
                id="propertyTypeId"
                className="ala-select"
                style={{ ...inputStyle(!!formError.propertyTypeId), appearance: 'none', cursor: 'pointer' }}
                value={form.propertyTypeId}
                onChange={changeHandler}
              >
                <option value="">— Select Property —</option>
                {PropertyType.map(({ id, name }) => (
                  <option key={id} value={id}>{name}</option>
                ))}
              </select>
              {formError.propertyTypeId && <p style={errorStyle}><i className="fas fa-exclamation-circle" />{formError.propertyTypeId}</p>}
            </div>
          </div>

          {/* Row 3: Conversation Comments full width */}
          <div style={{ paddingBottom: '10px', borderBottom: '1.5px solid #f0f2f5', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px' }}>
            <div style={{ width: '30px', height: '30px', borderRadius: '8px', background: '#fb634018', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fb6340', fontSize: '13px' }}>
              <i className="fas fa-comment-dots" />
            </div>
            <p style={{ fontSize: '13px', fontWeight: '700', color: '#344767', textTransform: 'uppercase', letterSpacing: '0.06em', margin: 0 }}>
              Conversation Notes
            </p>
          </div>
          <div className="row g-3">
            <div className="col-12">
              <label style={labelStyle} htmlFor="conversationcomment">Conversation Comments</label>
              <textarea
                rows="4"
                id="conversationcomment"
                name="conversationcomment"
                className="ala-input"
                style={{ ...inputStyle(!!formError.conversationcomment), resize: 'vertical', minHeight: '100px' }}
                placeholder="Enter conversation details, client interests, key discussion points…"
                onChange={changeHandler}
                value={form.conversationcomment}
              />
              {formError.conversationcomment && <p style={errorStyle}><i className="fas fa-exclamation-circle" />{formError.conversationcomment}</p>}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: '20px 28px',
          background: '#f8f9fe',
          borderTop: '1.5px solid #f0f2f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '12px',
        }}>
          <button
            type="button"
            className="ala-cancel-btn"
            onClick={resetForm}
            style={{
              background: 'transparent',
              border: '1.5px solid #e9ecef',
              borderRadius: '10px',
              padding: '10px 24px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#8392ab',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >
            <i className="fas fa-undo" style={{ marginRight: '7px' }} />
            Reset
          </button>
          <button
            type="button"
            className="ala-submit-btn"
            onClick={onLeadAssignedSubmit}
            style={{
              background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
              border: 'none',
              borderRadius: '10px',
              padding: '10px 32px',
              fontSize: '14px',
              fontWeight: '700',
              color: '#fff',
              cursor: 'pointer',
              boxShadow: '0 4px 15px rgba(52,71,103,0.3)',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s',
            }}
          >
            <i className="fas fa-clipboard-check" />
            Save Assignment
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddLeadsAssigned;
